module.exports = __webpack_public_path__ + "static/img/16jixuqianjin.163ca387.gif";